import * as T from './helpers.types';

export const parseDuration = ({ duration }: T.IParseDurationParam): T.IParseDurationReturn => {
  return {
    hours: Math.floor(duration / 3600),
    minutes: Math.floor((duration % 3600) / 60),
    seconds: duration % 60,
  };
};

export const formatDuration = ({
  duration,
  isRemainingDuration = false,
}: T.IFormatDurationParam): string => {
  const prefix = isRemainingDuration ? '-' : '';
  const { hours, minutes, seconds } = parseDuration({
    duration,
  });
  const minutesFormatted = minutes.toString().padStart(2, '0');
  const secondsFormatted = seconds.toString().padStart(2, '0');

  return hours > 0
    ? `${prefix}${hours}:${minutesFormatted}:${secondsFormatted}`
    : `${prefix}${minutesFormatted}:${secondsFormatted}`;
};
